import React from 'react';
import {
    Card, CardContent, Container, Typography
} from '@material-ui/core';
import { FORM_ACTIONS } from 'src/utils/constants/general';
import Page from '../Page';
import ErrorsValidation from '../shared/displayErrorsValidations';
import FormFooter from './shared/FormFooter';
import PageContainer from 'src/containers/shared/PageContainer';

const AddFooter = (props) => {
  const {
    errors,
    loading,
    paginasInst,
    portadas,
    addFooter,
  } = props;

  return (
    <PageContainer title="Agregar Pie de Página" maxWidth={false}>
        <Typography
          color="textPrimary"
          variant="h2"
          className="mb-3"
        >
          Agregando Pie de Página
        </Typography>
        <ErrorsValidation errors={errors} />
        <Card>
          <CardContent>
            <FormFooter
              action={FORM_ACTIONS.ADD}
              addFooter={addFooter}
              loading={loading}
              paginasInst={paginasInst}
              portadas={portadas}
            />
          </CardContent>
        </Card>
    </PageContainer>
  );
};

export default AddFooter;
